<template>
    <div class="tabs">
        <div class="flex tabs__container justify-between items-center"
            :class="{loaded}"
        >
            <div class="flex items-center tabs__scroll overflow-auto">
                <div
                    v-for="(tab, index) of tabs"
                    :key="index"
                    class="p-4 tabs__item whitespace-no-wrap tabs-link"
                    :class="{active: activeTab === index, 'cursor-pointer': activeTab !== index}"
                    @click="changeTab(index)"
                >
                    <div>
                        <div v-if="tab.hasOwnProperty('count')">{{ translate ? $t(tab.name) : tab.name }} - {{ tab.count }}</div>
                        <div v-else>{{ translate ? $t(tab.name) : tab.name }}</div>
                    </div>
                </div>
            </div>
            <div v-if="panel">
                <slot name="panel"></slot>
            </div>
        </div>

        <div class="tabs__content mt-4" ref="tabsContent">
            <div v-if="!display"
                 class="tabs__loader"
                 :style="{height: contentHeight}"
            >
                <c-loader color="rgba(var(--vs-primary), 1)"></c-loader>
            </div>

            <transition v-if="transition" name="slide-fade">
                <slot v-if="display"></slot>
            </transition>

            <slot v-if="display && !transition"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        view: {
            type: String,
            validator: value => {
                return ['vertical', 'horizontal'].includes(value)
            },
            default: () => 'horizontal'
        },

        transition: {
            type: Boolean,
            default: true
        },

        panel: {
            type: Boolean,
            default: false
        },

        translate: {
            type: Boolean,
            default: false
        },

        tabs: {
            type: Array,
            required: true
        },

        activeTab: {
            type: Number,
            default: 0
        },

        loaded: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            display: true,
            contentHeight: 0
        }
    },

    watch: {
        activeTab() {
            this.display = true
        }
    },

    methods: {
        changeTab(index) {
            if (this.activeTab !== index) {
                this.contentHeight = this.$refs.tabsContent.clientHeight + 'px'
                this.$emit('selected', index, true)
                this.display = false
            }
        }
    }
}
</script>

<style lang="scss">
.tabs {
    .loaded {
        pointer-events: none;
    }

    .active-line {
        &:after {
            content: '';
            display: block;
            position: absolute;
            bottom: 0;
            width: 100%;
            height: 2px;
            background-color: rgba(var(--vs-primary), 1);
        }
    }

    &-link {
         &.active {
             position: relative;
             color: rgba(var(--vs-primary), 1);
             background: rgba(var(--vs-primary), .08);

             @extend .active-line
         }
    }

    &__scroll {
        width: 100%;

        &::-webkit-scrollbar {
            height: 1px;
        }

        &::-webkit-scrollbar-track {
            background: none;
        }

        &::-webkit-scrollbar-thumb {
            background: rgba(0, 0, 0, 0.2);
            border-radius: 6px;
        }
    }

    &__content {
        position: relative;
    }

    &__loader {
        position: absolute;
        top: 0;
        width: 100%;
        text-align: center;
        padding-top: 50px;
        padding-bottom: 50px;
    }

    &__container {
        background-color: white;
        border-radius: 0.5rem;
        overflow: hidden;
    }

    &__item {
        display: flex;
        justify-content: center;
        transition: all .25s ease;

        &:hover {
            @extend .active;
            transition: all .25s ease;
        }
    }
}
</style>
